<template>
  <div class="pageHome">
    <!-- <Navbar ref="login" /> -->
    <div class="container h-100">
      <b-row class="row h-100 justify-content-center align-items-center">
        <b-col class="col-12 col-sm-10 col-md-10 col-lg-10 font-weight-normal text-dark text-center">
          <img src="../assets/img/swine-project.png" class="w-100" alt="...">
        </b-col>
        <b-col class="col-6 col-sm-6 col-md-6 col-lg-4">
          <b-row class="row p-4">
            <b-col class="col-12 rounded-20 shadow bg-company">
              <router-link :to="{name: 'company'}"><img src="../assets/img/swine-company.png" class="w-100 hover-up" alt="..."></router-link>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-6 col-sm-6 col-md-6 col-lg-4">
          <b-row class="row p-4">
            <b-col class="col-12 rounded-20 shadow bg-promote">
              <router-link :to="{name: 'promote'}"><img src="../assets/img/swine-promote.png" class="w-100 hover-up" alt="..."></router-link>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-12"><h1 class="my-3">&nbsp;</h1></b-col>
        <!-- <div class="col-12 font-weight-normal text-light text-center p-1">
          <p class="text-muted">&copy; Smartfarm Solution Developed By Feed Business</p>
          <p class="text-muted">CPF (Thailand) Public Company Limited</p>
        </div> -->
      </b-row>
      <!-- <b-row v-if="showFarm">
        <b-col class="col-12">
          <b-row class="row mt-3 p-1 justify-content-center">
            <b-col class="col-6 col-sm-4 col-md-4 col-lg-2 text-light">
              แสดงฟาร์มทั้งหมด
            </b-col>
            <b-col class="col-6 col-sm-4 col-md-4 col-lg-2 text-light">
              {{farm_id}}
            </b-col>
            <b-col class="col-6 col-sm-4 col-md-4 col-lg-2 text-light">
              {{name}}
            </b-col>
          </b-row>
        </b-col>
      </b-row> -->
      <Footer />
    </div>
  </div>
</template>

<script>
// import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "home",
  components: {
    // Navbar,
    Footer
  },
  data() {
    return {
      showFarm: false,
      farm_id: [],
      name: [],
      groupFarm: '',
      groupCompany: false,
      groupPromote: false
    }
  },
  mounted() {
    if(this.$store.getters.loggedIn === false) {
      this.$nextTick(() => {
        this.$router.push({
          name: "login"
        });
      });
    }
    else {
      localStorage.removeItem('farm_id')
    }
  },
  methods: {
    // viewFarm() {
    //   this.$store.dispatch('viewFarm')
    //   .then(response => {
    //     if(response.data.success == 1) {
    //       for(let i = 0 ; i < response.data.data.length ; i++) {
    //         this.farm_id.push(response.data.data[i].farm_id)
    //         this.name.push(response.data.data[i].name)
    //       }          
    //       this.showFarm = true
    //     }
    //   })
    // },
    selectGroupFarm(group) {
      if(group == "company") {
        this.$nextTick(() => {
          this.$router.push({
            name: "company",
          });
        });
      }
      else if(group == "promote") {
        this.$nextTick(() => {
          this.$router.push({
            name: "promote",
          });
        });
      }
    }
  }
};
</script>

<style>
@import "../assets/css/Page.css";
@import "../assets/css/Font.css";

  .pageHome {
    height: 100%;
    background: #bcf1ff;
    background: -moz-linear-gradient(top,  #FFF 0%, #FFF 50%, #bcf1ff 50%, #A2F9CA 100%); /* FF3.6+ */
    background: -webkit-gradient(linear, left top, right top, color-stop(0%,#FFF), color-stop(50%,#FFF), color-stop(50%,#bcf1ff), color-stop(100%,#A2F9CA)); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(top,  #FFF 0%,#FFF 50%,#bcf1ff 50%,#A2F9CA 100%); /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(top,  #FFF 0%,#FFF 50%,#bcf1ff 50%,#A2F9CA 100%); /* Opera 11.10+ */
    background: -ms-linear-gradient(top,  #FFF 0%,#FFF 50%,#bcf1ff 50%,#A2F9CA 100%);  /*IE10+*/
    background: linear-gradient(to bottom,  #FFF 0%,#FFF 50%,#bcf1ff 50%,#A2F9CA 100%); /* W3C */
  }

  .page {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .btn:disabled, input:disabled, select:disabled {
    cursor: not-allowed;
  }
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px 555555; 
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: #00FFFF; 
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #00FFFF; 
  }
  
  .bg-promote {
    background-color: #69140e;
    background-image: linear-gradient(315deg, #69140e 0%, #d58936 74%);
  }
  .bg-company {
    background-color: #0d0a0b;
    background-image: linear-gradient(315deg, #0d0a0b 0%, #009fc2 74%);
  }
  .rounded-20{
    border: 0px solid #ffffff;
    padding: 10px;
    border-radius: 20px;
  }
  .hover-up {
    transform: scale(1);
    transition: .3s ease;
    cursor: pointer;
  }
  .hover-up:hover {
      transform: scale(0.9);
  }
</style>
